import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-more-loading',
  templateUrl: './more-loading.component.html',
  styleUrls: ['./more-loading.component.scss']
})
export class MoreLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
